import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';

import { getBookingWidgetMultipropertyData } from 'features/multiproperty/MultipropertySlice';
import { Stars } from 'components/common/stars';
import { SmallTextMultipropertyWidget } from 'components/smallTextMultipropertyWidget';
// import './MultipropertyCarouselWidget.css';

const SmallMultipropertySingleProperty = ({
    singleProperty,
    propertyIndex,
}) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.miniBookingWidget?.data) || {};
    const widgetPosition = useSelector(
        (state) => state.miniBookingWidget.widgetPosition
    );
    const { showMultipropertySmallBtn, Lang } = data;

    // const multipropertyBestPriceText = useSelector(
    //     (state) =>
    //         state.miniBookingWidget?.multipropertyData
    //             ?.multiPropertyBestDealText
    // );

    const multipropertyUrl = useSelector(
        (state) => state.miniBookingWidget?.data?.multipropertyUrl
    );

    const multiPropertyCount = useSelector(
        (state) =>
            state.miniBookingWidget?.multipropertyData?.multiPropertyCount
    );

    useEffect(() => {
        if (multipropertyUrl) {
            dispatch(
                getBookingWidgetMultipropertyData({
                    multipropertyUrl,
                })
            );
        }
    }, [multipropertyUrl]);

    const isOpen = useSelector((state) => state.miniBookingWidget.open);
    const isDismissed = useSelector(
        (state) => state.miniBookingWidget.isDismissed
    );

    const inlineStyles = {};

    if (data.pluginZIndex) {
        inlineStyles.zIndex = data.pluginZIndex;
    }

    if (isDismissed) {
        return null;
    }

    return (
        <>
            {isOpen && (
                <div className="ab-multiproperty-widget-card-background">
                    <div className="ab-multiproperty-widget-body multiprop_carousel">
                        <div className="ab-multiproperty-widget-card singleprop ab-multiprop-card ab_mpc_1 active">
                            <div className="ab-widget-row">
                                <div
                                    className="ab-multiproperty-widget-rates"
                                    style={{
                                        width: '100%',
                                    }}
                                >
                                    <div className="ab-multiproperty-widget-rates-image-container">
                                        <span className="ab-img-center-helper"></span>
                                        <img
                                            src={singleProperty.propertyLogo}
                                        />
                                    </div>
                                    <div className="ab-multiproperty-widget-multiproperty-body">
                                        <div className="ab-multiproperty-widget-multiproperty-details">
                                            <div
                                                className="ab-small-margin-bottom ab-inline-class"
                                                style={{
                                                    justifyContent:
                                                        'space-around',
                                                }}
                                            >
                                                <span
                                                    className="ab-font-size-large"
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#c72d2d',
                                                    }}
                                                >
                                                    {/* {multipropertyBestPriceText} */}
                                                    {Lang.dealsFrom}{' '}
                                                    {multiPropertyCount}{' '}
                                                    {Lang.hotels}
                                                </span>
                                            </div>
                                            {/* <p className="ab-no-margin-top ab-multiprop-subtitle">
                                                {Lang.dealsFrom}{' '}
                                                {multiPropertyCount}{' '}
                                                {Lang.hotels}
                                            </p> */}
                                            <hr className="ab-multiproperty-widget-multiproperty-details-hr" />
                                        </div>
                                        <div
                                            className="ab-flex-class"
                                            style={{
                                                justifyContent: 'space-around',
                                            }}
                                        >
                                            <div className="ab-multiproperty-widget-multiproperty-bottom-details">
                                                <div className="ab-font-size-medium ab-no-margin-top multiprop_hotel_name">
                                                    {
                                                        singleProperty.propertyName
                                                    }
                                                    <span className="ab-font-size-small ab-font-weight-bold ab-greater-than">
                                                        <FaChevronRight
                                                            size={14}
                                                        />
                                                    </span>
                                                </div>
                                                {singleProperty.lowestPrice &&
                                                singleProperty.lowestPrice !==
                                                    0 ? (
                                                    <>
                                                        <p className="ab-font-size-medium ab-no-margin-top ab_prices_section ab-text-center">
                                                            From{' '}
                                                            <span className="ab_property_price">
                                                                {
                                                                    singleProperty.lowestPrice
                                                                }
                                                                €
                                                                {singleProperty
                                                                    .ourPrice
                                                                    ?.hasMinStay && (
                                                                    <span className="ab-carousel-min-price">
                                                                        Min-Stay
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </p>
                                                    </>
                                                ) : (
                                                    singleProperty.totalScoreDecimal !==
                                                        0 &&
                                                    singleProperty.totalReviews && (
                                                        <div className="ab-font-size-medium ab-no-margin-top ab_scoreSpan ab-text-center">
                                                            <span>
                                                                <Stars
                                                                    rating={1}
                                                                    size={15}
                                                                />
                                                            </span>
                                                            <span
                                                                style={{
                                                                    paddingRight:
                                                                        '3px',
                                                                }}
                                                            >
                                                                <b>
                                                                    {
                                                                        singleProperty.totalScoreDecimal
                                                                    }
                                                                </b>{' '}
                                                                Score from{' '}
                                                            </span>
                                                            <span>
                                                                <b>
                                                                    {
                                                                        singleProperty.totalReviews
                                                                    }
                                                                </b>
                                                            </span>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {!isOpen && showMultipropertySmallBtn && (
                // <MultipropertySmallWidgetButton
                //     Lang={Lang}
                //     multiPropertyCount={multiPropertyCount}
                // />
                <SmallTextMultipropertyWidget
                    position={widgetPosition.position.split('-')[1]}
                />
            )}
        </>
    );
};

SmallMultipropertySingleProperty.propTypes = {
    price: PropTypes.string,
    text: PropTypes.string,
    rateType: PropTypes.string,
    currencySymbol: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    link: PropTypes.bool,
    url: PropTypes.string,
    singleProperty: PropTypes.object,
    propertyIndex: PropTypes.number,
};

SmallMultipropertySingleProperty.defaultProps = {
    className: '',
};

export default SmallMultipropertySingleProperty;
